import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, link }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <a href={link} className="text-light">
        <div className="proj-imgbx">
          <img alt={title} src={imgUrl} />
          <div className="proj-txtx">
            <h3>{title}</h3>
            <span>{description}</span>
          </div>
        </div>
      </a>
    </Col>
  )
}
